"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTournamentsScores = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useGetTournamentsScores = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.TOURNAMENT_SCORES,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, data = _c.data, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        getTournamentScores: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, data, error]);
};
exports.useGetTournamentsScores = useGetTournamentsScores;
